import { render, staticRenderFns } from "./otherChat.vue?vue&type=template&id=17f65f5b&scoped=true"
import script from "./otherChat.vue?vue&type=script&lang=js"
export * from "./otherChat.vue?vue&type=script&lang=js"
import style0 from "./otherChat.vue?vue&type=style&index=0&id=17f65f5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f65f5b",
  null
  
)

export default component.exports